import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";

export default function GroupManagerPopup({
  open,
  sessionName,
  availableSubSessions = [],
  initialGroup = null,
  onClose,
  onSave,
}) {
  const options = useMemo(
    () =>
      availableSubSessions.map((item) => ({
        value: item.sub_session_id,
        label: item.sub_session_name,
      })),
    [availableSubSessions]
  );
  const [title, setTitle] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (!open) {
      return;
    }

    const selectedIds =
      initialGroup && initialGroup.selectedSubSessionIds
        ? initialGroup.selectedSubSessionIds
        : [];
    const selectedValues = options.filter((item) =>
      selectedIds.includes(item.value)
    );

    setTitle(initialGroup && initialGroup.title ? initialGroup.title : "");
    setSelectedOptions(selectedValues);
  }, [initialGroup, open, options]);

  if (!open) {
    return null;
  }

  const submitHandler = () => {
    if (!title.trim()) {
      toast.error("Please enter a group title.", { position: "top-center" });
      return;
    }

    if (!selectedOptions.length) {
      toast.error("Please select at least one subsession.", {
        position: "top-center",
      });
      return;
    }

    onSave({
      title: title.trim(),
      selectedSubSessionIds: selectedOptions.map((item) => item.value),
    });
  };

  return (
    <div className="group-manager-modal">
      <div className="group-manager-modal__backdrop" onClick={onClose}></div>
      <div className="group-manager-modal__dialog" role="dialog" aria-modal="true">
        <div className="group-manager-modal__header">
          <div>
            <h4>{initialGroup ? "Edit Group" : "Add Group"}</h4>
            <p>{sessionName || "Session"}</p>
          </div>
          <button
            type="button"
            className="group-manager-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            x
          </button>
        </div>

        <div className="group-manager-modal__body">
          <div className="group-manager-modal__field">
            <label htmlFor="group-title">Title</label>
            <input
              id="group-title"
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              placeholder="Enter group title"
            />
          </div>

          <div className="group-manager-modal__field">
            <label>Subsession List</label>
            <Select
              className="group-manager-modal__select"
              classNamePrefix="group-manager-select"
              options={options}
              isMulti
              closeMenuOnSelect={false}
              value={selectedOptions}
              onChange={(value) => setSelectedOptions(value || [])}
              placeholder="Select subsessions"
            />
          </div>
        </div>

        <div className="group-manager-modal__actions">
          <button
            type="button"
            className="group-manager-modal__secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="group-manager-modal__primary"
            onClick={submitHandler}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
